import axios from 'axios';
import { from } from 'rxjs';

export const checkSalesOrdersCustomsStatus = (salesOrderIds) => {
  const request = axios.post('customs/salesOrder/checkStatus', {
    salesOrderIds,
  });
  return from(request);
};

export const checkFulfillmentPlanCustomsStatus = (fulfillmentPlanIds) => {
  const request = axios.post('customs/fulfillmentPlan/checkStatus', {
    fulfillmentPlanIds,
  });
  return from(request);
};

export const checkBatchCustomsStatus = (fulfillmentPlanSetId) => {
  const request = axios.post('customs/fulfillmentPlanSet/checkStatus', {
    fulfillmentPlanSetId,
  });
  return request;
};
